import { useQuery } from 'react-apollo';

import useSliceFilterOpts from '../../../../components/product/hooks/useSliceFilterOpts';
import { AccountRosterIdentities } from './graphql/queries';

const useAccountAddressBook = ({ limit = 100 }) => {
  const { filter, onFilterUpdate, onPageChange } = useSliceFilterOpts({
    initialFilter: {
      limit,
      searchQuery: '',
    },
  });

  const { data: { me: user } = {}, loading, error, refetch } = useQuery(
    AccountRosterIdentities,
    {
      variables: {
        limit: filter.limit,
        offset: filter.offset,
        search_query: filter.searchQuery,
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  const addressBook = user?.roster_identities.records ?? [];
  const addressBookTotal = user?.roster_identities.total ?? 0;

  const onAddressBookReset = () => {
    const resetVariables = { page: 0, offset: 0, searchQuery: '' };
    onFilterUpdate(resetVariables);
    refetch({ page: 0, offset: 0, searchQuery: '' });
  };

  return {
    filter,
    onFilterUpdate,
    onPageChange,
    loading,
    error,
    addressBook,
    addressBookTotal,
    onAddressBookReset,
    hasSelectedTiers: user?.custom_print_tiers?.total > 0,
  };
};

export default useAccountAddressBook;
